import { AUTOMATION_EMAILS } from "@stadium/constants";

export const isAutomationEmail = (emailValue) => AUTOMATION_EMAILS.includes(emailValue);

export const isGmailAccount = (emailValue) => {
  if (typeof emailValue !== "string") {
    return false;
  }
  return emailValue.toLowerCase().includes("@gmail");
};
